import { BinaryLogo, CompetitorLogo } from './competitor-logo';

type RoundupLogoProps = {
	/** Icon file key under `public/images/compare/`, or "binary" for Binary's own mark. */
	logo: string;
	name: string;
	size?: 'sm' | 'md' | 'lg';
	className?: string;
};

/**
 * Logo for a tool in the best-free-ats roundup, which mixes Binary, compare-page
 * competitors and tools with no compare page. Resolves the special "binary" key
 * to `BinaryLogo`; anything else is a file key for `CompetitorLogo`.
 */
export const RoundupLogo = ({ logo, name, size = 'md', className }: RoundupLogoProps) =>
	logo === 'binary' ? (
		<BinaryLogo
			size={size}
			className={className}
		/>
	) : (
		<CompetitorLogo
			slug={logo}
			name={name}
			size={size}
			className={className}
		/>
	);
